
import React from 'react';
import Layout from '@/components/Layout';
import { useUser } from '@/context/UserContext';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import ProgressSummarySection from '@/components/journey/ProgressSummarySection';
import JourneySection from '@/components/journey/JourneySection';

const Calendar = () => {
  const { userProgress } = useUser();
  
  return (
    <Layout>
      <div className="container py-4 max-w-5xl mx-auto px-3 md:px-4">
        <DashboardHeader 
          title="30-Day Plan" 
          description="Track your progress through personalized daily lessons"
        />
        
        <div className="space-y-6 animate-in fade-in-50">
          {/* Progress summary cards */}
          <ProgressSummarySection userProgress={userProgress} />
          
          {/* Journey view */}
          <JourneySection userProgress={userProgress} />
        </div>
      </div>
    </Layout>
  );
};

export default Calendar;
